import { ConstData } from "@constants/helpers"
import { Day } from "@models/day"
import { Term } from "@models/term"
import { Campus } from "@models/campus"

export class ClassesManagerState {

  constructor(
    public activeTerm: Term = null,
    public activeCampus: Campus = null,
    public activeDay: Day = null,
    public activeHolidayWeek: number = 1,
  ) {}

  public static clone(obj: any) {
    const state: ClassesManagerState = new this()

    if (obj.activeCampus) { state.activeCampus = obj.activeCampus }
    if (obj.activeDay) { state.activeDay = obj.activeDay }
    if (obj.activeTerm) { state.activeTerm = obj.activeTerm }
    if (obj.activeHolidayWeek) { state.activeHolidayWeek = obj.activeHolidayWeek }

    return state
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/states/classes-manager.ts